import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { addInventory, searchProducts } from '../services/inventoryService';
import { validateInventory } from '../validations/inventoryValidation';
import { showSuccessToast } from '../../../utils/toastHelper';
import { AsyncPaginate } from 'react-select-async-paginate';

const AddInventoryModal = ({ setAddModal, onSuccess }) => {
  const { t } = useTranslation('Inventory');
  const [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    product_id: '',

    stock_in: null,
  });
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({});

  // const [searchQuery, setSearchQuery] = useState('');
  // const [loading, setLoading] = useState(false);

  // const fetchProduct = async (search, page = 1) => {
  //   setLoading(true);

  //   const per_page = 50;
  //   const query = { page, per_page, search };

  //   const productsResponse = await searchProducts(query);

  //   if (productsResponse.products) {
  //     const codeOptions = productsResponse.products.map((product) => ({
  //       value: product.id,
  //       label: product.code,
  //       product_name: product.name,
  //       product_code: product.code,
  //     }));

  //     const nameOptions = productsResponse.products.map((product) => ({
  //       value: product.id,
  //       label: product.name,
  //       product_name: product.name,
  //       product_code: product.code,
  //     }));

  //     setProducts({ codeOptions, nameOptions });
  //   }
  //   setLoading(false);
  // };
  // console.log('poducts;;;;;', products);
  // useEffect(() => {
  //   if (searchQuery) {
  //     fetchProduct(searchQuery);
  //   } else {
  //     fetchProduct([]);
  //   }
  // }, [searchQuery]);
  const productsLoadOptions =
    (labelType = 'code') =>
    async (inputValue, loadedOptions, { page }) => {
      const per_page = 50;
      const query = { page, per_page, search: inputValue, FBZ: 1 };

      const productsResponse = await searchProducts(query);

      setProducts((prev) => [...prev, ...(productsResponse?.products || [])]);

      const newOptions = productsResponse.products?.map((product) => ({
        value: product.id,
        label: labelType === 'code' ? `${product.code}` : `${product.name}`,
      }));

      return {
        options: newOptions,
        hasMore:
          productsResponse.pagination.current_page <
          productsResponse.pagination.last_page,
        additional: {
          page: page + 1,
        },
      };
    };
  console.log('selectedProduct', selectedProduct);
  const handleProductChange = (selectedOption) => {
    if (!selectedOption) {
      setSelectedProduct(null);
      setFormData((prevData) => ({
        ...prevData,
        product_id: null,
      }));
      return;
    }
    console.log('selected ooption', selectedOption);
    const selectedProductOption = products.find(
      (product) => product.id === selectedOption.value
    );
    setSelectedProduct(selectedProductOption);
    setFormData((prevData) => ({
      ...prevData,
      product_id: selectedOption?.value || null,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = async () => {
    setLoader(true);
    const validationResult = await validateInventory(formData);
    if (!validationResult) {
      setLoader(false);

      return;
    }
    const response = await addInventory(formData);
    if (response.success) {
      onSuccess();
      setLoader(false); // Start loading
      setAddModal(false);
      showSuccessToast(response.message);

      return response;
    } else {
      setLoader(false);
    }
  };

  return (
    <div className="modal fade show d-block" id="add-new-inventory">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {t('FBZINVENTORYENTRY')}
            </h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => setAddModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="did-floating-label-content edit-product-change change-width">
              {/* <Select
                isLoading={loading}
                options={products.codeOptions}
                value={
                  products.codeOptions?.find(
                    (opt) => opt.value === formData.product_id
                  ) || null
                }
                onChange={handleProductChange}
                onInputChange={(newValue) => setSearchQuery(newValue)}
                placeholder={t('PRODUCTCODE')}
                isClearable
              /> */}
              <AsyncPaginate
                value={
                  selectedProduct?.id
                    ? {
                        value: selectedProduct.id,
                        label: selectedProduct.code,
                      }
                    : null
                }
                loadOptions={productsLoadOptions('code')}
                onChange={handleProductChange}
                placeholder={t('PRODUCTCODE')}
                isClearable
                additional={{
                  page: 1,
                }}
              />
            </div>
            <div className="did-floating-label-content edit-product-change change-width">
              {/* <Select
                isLoading={loading}
                options={products.nameOptions}
                value={
                  products.nameOptions.find(
                    (opt) => opt.value === formData.product_id
                  ) || null
                }
                onChange={handleProductChange}
                onInputChange={(newValue) => setSearchQuery(newValue)}
                placeholder={t('PRODUCTNAME')}
                isClearable
              /> */}
              <AsyncPaginate
                value={
                  selectedProduct?.id
                    ? {
                        value: selectedProduct.id,
                        label: selectedProduct.name,
                      }
                    : null
                }
                loadOptions={productsLoadOptions('name')}
                onChange={handleProductChange}
                placeholder={t('PRODUCTNAME')}
                isClearable
                additional={{
                  page: 1,
                }}
              />
            </div>

            {/* <div className="did-floating-label-content">
              <input
                className="did-floating-input"
                type="text"
                placeholder=" "
              />
              <img
                src="images/search-icon.svg"
                className="search-icon"
                alt=""
              />
              <label className="did-floating-label">{t('PRODUCTCODE')} </label>
            </div>
            <div className="did-floating-label-content">
              <input
                className="did-floating-input"
                type="text"
                placeholder=" "
              />
              <img
                src="images/search-icon.svg"
                className="search-icon"
                alt=""
              />
              <label className="did-floating-label">{t('PRODUCTNAME')} </label>
            </div> */}
            <div className="did-floating-label-content stock-in">
              <input
                className="did-floating-input "
                type="number"
                placeholder=" "
                name="stock_in"
                value={formData.stock_in}
                onChange={handleChange}
              />
              <label className="did-floating-label">{t('STOCKIN')} </label>
            </div>
            <div className="bottom-button">
              <button
                className={`save ${loader ? 'disable-btn' : ''}`}
                onClick={() => handleSubmit()}
                disabled={loader}
              >
                {' '}
                {loader && (
                  <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                  </div>
                )}
                {t('SAVE')}
              </button>
              <button
                className={`cancel ${loader ? 'disable-btn' : ''}`}
                onClick={() => setAddModal(false)}
                disabled={loader}
              >
                {t('CANCEL')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddInventoryModal;
